import banner from "./banner.jpg"
import logo from "./logo.jpg"

const shop = {
    id: "shop014",
  
    vendorId: "NlPMx4u4HharqZ017AXMJU6e3fs2",
  
    slug: "chicken-republic-uyo",
  
    name: "Chicken Republic",
  
    category: "food",
  
    rating: 4.5,
  
    deliveryTime: "20-30 mins",
  
    featured: true,
  
    logo: logo,
  
    banner: banner,

    size: "medium",

    products: [],

    location: "Uyo",

    deliveryPricing: {
      baseFee: 500,
      perKm: 180
    },

    location2: {
      area: "Wuse 2",
      city: "Abuja",
    
      coordinates: {
        lat: 9.0765,
        lng: 7.3986
      }
    },
   
  };
  
  export default shop;